module.exports = __webpack_public_path__ + "static/media/check.57920871.svg";